import styled from "styled-components";

export const Background = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   background-color: #f1a9ca;
`

export const Paragraph = styled.p`
    text-align:center;
    align-self: center;
    max-width: 75%;
    font-family: 'KiwiSoda';
    font-size: 2rem;
    color: #420942;
    @media (max-width: 767px) {
        font-size: 1.7rem;
    }
`
export const Gradient = styled.div`
    background: linear-gradient(#f1a9ca, #cbb9d9);
    min-height: 100px;
    @media (max-width: 767px) {
        min-height: 50px;
    }
`
export const Pink = styled.div`
    background-color: #f1a9ca;
    min-height: 100px;
`
export const OppGradient = styled.div`
    background: linear-gradient(#cbb9d9, #f1a9ca);
    min-height: 200px;
   
`

export const MyImage = styled.img`
    align-self: center;
    max-width: 40%;
`